import request from "helpers/api_helper";
import { toast } from "react-toastify";

export const getAdminSettings = async (params? : string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "admin_settings" + (params ? `?${params}` : ""),
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch admin settings");
    return error;
  }
};


export const getPublicAdminSettings = async (params? : string) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "admin_settings/public" + (params ? `?${params}` : ""),
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to fetch admin settings");
    return error;
  }
};

export const updateAdminSettings = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "admin_settings",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Settings updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update settings");
    return error;
  }
};

export const updatePublicAdminSettings = async (data: any) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "admin_settings/public",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    };
    const response = await request(args);
    if (response.success) {
      toast.success(response.message || "Settings updated successfully");
    }
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to update settings");
    return error;
  }
};

export const uploadImage = async (formData: FormData) => {
  try {
    const token = localStorage.getItem("token");
    const args = {
      url: "upload",
      method: "POST",
      headers: {
        Authorization: "Bearer " + token,
      },
      body: formData,
    };
    const response = await request(args);
    return response;
  } catch (error: any) {
    toast.error(error.message || "Failed to upload image");
    return error;
  }
};